import { store } from '@/plugins/store';
import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';

export const Permissions = {

    CONSULTER_DEMANDE_INTERVENTION: 'consulter.demande',
    CREER_DEMANDE_INTERVENTION: 'creer.demande',
    CONSULTER_INTERVENTION_NON_PREVENTIVE: 'consulter.interventionNP',
    CONSULTER_INTERVENTION_PREVENTIVE: 'consulter.interventionP',
    FOURNISSEUR: 'role.fournisseur',
    CLIENT: 'role.client',
    // A compléter...

    //on ouvre un toast si l'utilisateur tente d'accéder à une fonctionnalité pour laquelle il ne possède pas les droits
    async userCanAccess(...permissionNames: string[]): Promise<boolean> {
        for (const element of permissionNames) {
            if (element) {
                if (!store.getters.getUserInformations.fonctions.includes(element)) {
                    const error = {
                        response: {
                            status: 403,
                            data: {message: null }
                        }
                    };
                    store.commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processError(error),
                        { root: true }
                    );
                    return false;
                }
            }
        }
        return true;
    },

};
